/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/backtop.js":
/*!***************************!*\
  !*** ./src/js/backtop.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"backtop\": () => (/* binding */ backtop)\n/* harmony export */ });\nfunction backtop() {\n  $(function () {\n    var topBtn = $('.js-back-top');\n    topBtn.click(function () {\n      $('body,html').animate({\n        scrollTop: 0\n      }, 500);\n      return false;\n    });\n  });\n}\n\n//# sourceURL=webpack:///./src/js/backtop.js?");

/***/ }),

/***/ "./src/js/filter.js":
/*!**************************!*\
  !*** ./src/js/filter.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"filter\": () => (/* binding */ filter)\n/* harmony export */ });\n/* harmony import */ var _sp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sp */ \"./src/js/sp.js\");\n\nfunction filter() {\n  $(function () {\n    var jsFilter = $('.js-filter-btn');\n    var jsClose = $('.js-close-btn');\n    jsFilter.on('click', function () {\n      $('.side-bar').addClass('is-open');\n    });\n    jsClose.on('click', function () {\n      $('.side-bar').removeClass('is-open');\n    });\n  });\n}\n\n//# sourceURL=webpack:///./src/js/filter.js?");

/***/ }),

/***/ "./src/js/header.js":
/*!**************************!*\
  !*** ./src/js/header.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"header\": () => (/* binding */ header)\n/* harmony export */ });\n/* harmony import */ var _sp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sp */ \"./src/js/sp.js\");\n\nfunction header() {\n  /**\n  * グロナビの開閉\n  */\n  $(function () {\n    var jsSpMenu = $('.js-sp-menu');\n    jsSpMenu.on('click', function () {\n      $('#js-nav').toggleClass('is-open');\n      $(this).toggleClass('is-open');\n      $('body').toggleClass('is-open');\n    });\n  });\n}\n\n//# sourceURL=webpack:///./src/js/header.js?");

/***/ }),

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./header */ \"./src/js/header.js\");\n/* harmony import */ var _slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./slider */ \"./src/js/slider.js\");\n/* harmony import */ var _backtop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./backtop */ \"./src/js/backtop.js\");\n/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./filter */ \"./src/js/filter.js\");\n\n\n\n\n$(function () {\n  (0,_header__WEBPACK_IMPORTED_MODULE_0__.header)();\n  (0,_slider__WEBPACK_IMPORTED_MODULE_1__.slider)();\n  (0,_backtop__WEBPACK_IMPORTED_MODULE_2__.backtop)();\n  (0,_filter__WEBPACK_IMPORTED_MODULE_3__.filter)();\n});\n\n//# sourceURL=webpack:///./src/js/main.js?");

/***/ }),

/***/ "./src/js/slider.js":
/*!**************************!*\
  !*** ./src/js/slider.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"slider\": () => (/* binding */ slider)\n/* harmony export */ });\n/* harmony import */ var _sp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sp */ \"./src/js/sp.js\");\n\nfunction slider() {\n  $(function () {\n    centerSlider();\n    rightSlider();\n    detailSlider();\n    $(window).on('resize', function () {\n      centerSlider();\n      rightSlider();\n      detailSlider();\n    });\n\n    function centerSlider() {\n      if ((0,_sp__WEBPACK_IMPORTED_MODULE_0__.isSp)()) {\n        // スマホ向け（767px以下のとき）\n        $('.js-center-slider').not('.slick-initialized').slick({\n          autoplay: false,\n          autoplaySpeed: 2500,\n          speed: 800,\n          dots: false,\n          arrows: false,\n          centerMode: true,\n          centerPadding: '24%'\n        });\n      } else {\n        // PC向け\n        $('.js-center-slider.slick-initialized').slick('unslick');\n      }\n    }\n\n    function rightSlider() {\n      if ((0,_sp__WEBPACK_IMPORTED_MODULE_0__.isSp)()) {\n        // スマホ向け（767px以下のとき）\n        $('.js-right-slider').not('.slick-initialized').slick({\n          autoplay: false,\n          autoplaySpeed: 2500,\n          speed: 800,\n          dots: false,\n          arrows: true,\n          prevArrow: '<span class=\"slide-arrow prev-arrow\"></span>',\n          nextArrow: '<span class=\"slide-arrow next-arrow\"></span>'\n        });\n      } else {\n        // PC向け\n        $('.js-right-slider.slick-initialized').slick('unslick');\n      }\n    }\n\n    function detailSlider() {\n      if ((0,_sp__WEBPACK_IMPORTED_MODULE_0__.isSp)()) {\n        // スマホ向け（767px以下のとき）\n        $('.js-detail-slider').not('.slick-initialized').slick({\n          autoplay: false,\n          autoplaySpeed: 2500,\n          speed: 800,\n          dots: false,\n          arrows: true,\n          prevArrow: '<span class=\"slide-arrow prev-arrow\"></span>',\n          nextArrow: '<span class=\"slide-arrow next-arrow\"></span>'\n        });\n      } else {\n        // PC向け\n        $('.js-detail-slider.slick-initialized').slick('unslick');\n      }\n    }\n  });\n}\n\n//# sourceURL=webpack:///./src/js/slider.js?");

/***/ }),

/***/ "./src/js/sp.js":
/*!**********************!*\
  !*** ./src/js/sp.js ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"isSp\": () => (/* binding */ isSp)\n/* harmony export */ });\nfunction isSp() {\n  var w = $(window).width();\n\n  if (w <= 767) {\n    return true;\n  } else {\n    return false;\n  }\n}\n\n//# sourceURL=webpack:///./src/js/sp.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/main.js");
/******/ 	
/******/ })()
;